export class BackLink {
    constructor() {
        this.browserBack();
    }

    private browserBack() {
      const browserBackLinks: NodeListOf<HTMLLinkElement> = document.querySelectorAll('.js-back-link');

      browserBackLinks?.forEach(browserBackLink => {
        browserBackLink.addEventListener('click', (event) => {
          event.preventDefault();

          window.history.go(-1);
        });
      });
    }
}